import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import Lottie from "lottie-react";
import successAnimation from "../../../../assets/lottie/success.json"; // ✅ Checkmark animation
import errorAnimation from "../../../../assets/lottie/error.json"; // ❌ Cross animation
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../../Styles/Styles";
import { useNavigate } from "react-router-dom";

const AdStatusModal = ({ open, type, message, adID, setStatusModal }) => {
  const navigate = useNavigate();

  const handleCloseStatusModal = () => {
    setStatusModal({ open: false, type: "", message: "", adID: null });
    navigate("/my-ads"); // or wherever you want to redirect
  };
  return (
    <Dialog
      open={open}
      onClose={handleCloseStatusModal}
      aria-labelledby="ad-status-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Lottie
          animationData={type === "success" ? successAnimation : errorAnimation}
          style={{ width: 120, height: 120 }}
          loop={false}
        />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "ClashGrotesk-Regular",
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        {type === "success" ? (
          <Button
            onClick={() => navigate(`/ad/${adID}`)}
            variant="contained"
            sx={{ ...primaryButtonStyles }}
          >
            View This Ad
          </Button>
        ) : (
          <Button
            onClick={() => {
              setStatusModal({ open: false, type: "", message: "" });
            }}
            variant="contained"
            sx={{ ...primaryButtonStyles }}
          >
            Try Again
          </Button>
        )}

        <Button
          onClick={handleCloseStatusModal}
          variant="contained"
          sx={{ ...secondaryButtonStyles }}
        >
          Back to My Ads
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdStatusModal;
